import React, { useCallback, useContext, useMemo, useState } from "react";
import _ from "lodash";

const AIMemoSectionContext = React.createContext<{
  selectedAIMemoSectionIdForEditDialog: number | null;
  handleEditDialogAIMemoSectionIdChange: (params: {
    sectionId: number | null;
  }) => void;
  isSourceDocumentDrawerOpen: boolean;
  handleSelectedSourceDocumentId: ({ value }: { value: number | null }) => void;
  selectedSourceDocumentId: number | null;
}>({
  selectedAIMemoSectionIdForEditDialog: null,
  handleEditDialogAIMemoSectionIdChange: () => {
    throw new Error("handleEditDialogAIMemoSectionIdChange not implemented");
  },
  isSourceDocumentDrawerOpen: false,
  selectedSourceDocumentId: null,
  handleSelectedSourceDocumentId: () => {
    throw new Error("handleSelectedSourceDocumentId not implemented");
  },
});

export interface AIMemoSectionProviderProps {
  children?: React.ReactNode;
}

export const AIMemoSectionProvider = ({
  children,
}: AIMemoSectionProviderProps) => {
  const [
    selectedAIMemoSectionIdForEditDialog,
    setSelectedAIMemoSectionIdForEditDialog,
  ] = useState<number | null>(null);

  const [selectedSourceDocumentId, setSelectedSourceDocumentId] = useState<
    number | null
  >(null);

  const isSourceDocumentDrawerOpen = useMemo(
    () => !_.isNil(selectedSourceDocumentId),
    [selectedSourceDocumentId]
  );

  const handleSelectedSourceDocumentId = useCallback(
    ({ value }: { value: number | null }) => {
      setSelectedSourceDocumentId(value);
    },
    []
  );

  const handleEditDialogAIMemoSectionIdChange = useCallback(
    ({ sectionId }: { sectionId: number | null }) => {
      setSelectedAIMemoSectionIdForEditDialog(sectionId);
    },
    []
  );

  return (
    <AIMemoSectionContext.Provider
      value={{
        selectedAIMemoSectionIdForEditDialog,
        handleEditDialogAIMemoSectionIdChange,
        isSourceDocumentDrawerOpen,
        selectedSourceDocumentId,
        handleSelectedSourceDocumentId,
      }}
    >
      {children}
    </AIMemoSectionContext.Provider>
  );
};

export const useAIMemoSection = () => {
  return useContext(AIMemoSectionContext);
};
